export const COLLECTOR_PORTAL_DEV = 'https://corporate-uat.collectordev.se'
export const COLLECTOR_PORTAL_PROD = 'https://corporate.collector.se/'
